// // src/components/ChatBot/MessageComponents.js
// import React, { useEffect } from 'react';
// import { PulseLoader } from 'react-spinners';
// import { useChat } from './ChatContext';

// const MessageWithRating = ({ message, index }) => {
//   const [showCorrection, setShowCorrection] = React.useState(false);

//   return (
//     <div
//       key={index}
//       className={`message-wrapper ${
//         message.role === 'user' ? 'message-wrapper-user' : 'message-wrapper-bot'
//       }`}
//     >
//       <div className="message-container">
//         <div
//           className={`message-bubble ${
//             message.role === 'user'
//               ? 'message-bubble-user'
//               : 'message-bubble-bot'
//           }`}
//         >
//           {message.content}
//         </div>

//         {/* Only show rating/correction for user messages */}
//         {message.role === 'user' && (
//           <div className="message-rating">
//             {message.rating !== undefined && message.rating !== null ? (
//               <>
//                 {/* Flex container for points and toggle button */}
//                 <div className="rating-container">
//                   <span>Points earned: +{message.rating}</span>
//                   {message.correctedSentence && (
//                     <button
//                       onClick={() => setShowCorrection(!showCorrection)}
//                       className="correction-toggle"
//                     >
//                       {showCorrection ? "▲" : "▼"}
//                     </button>
//                   )}
//                 </div>

//                 {/* Correction box */}
//                 {showCorrection && message.correctedSentence && (
//                   <div className="correction-box">
//                     {message.correctedSentence}
//                   </div>
//                 )}
//               </>
//             ) : (
//               // If rating is null/undefined, show "Calculating..."
//               <span>
//                 Calculating points... <PulseLoader size={4} color="#888" />
//               </span>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export const MessageList = () => {
//   const { 
//     messages, 
//     chatContainerRef, 
//     isLoading, 
//     isWaitingForResponse 
//   } = useChat();

//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//     }
//   }, [messages, isWaitingForResponse]);

//   return (
//     <div
//       ref={chatContainerRef}
//       className="message-list-container"
//     >
//       {isLoading ? (
//         <div className="loading-message">Loading messages...</div>
//       ) : (
//         <>
//           {Array.isArray(messages) && messages.length > 0 ? (
//             messages.map((message, index) => (
//               <MessageWithRating key={index} message={message} index={index} />
//             ))
//           ) : (
//             <div className="empty-message">No messages yet</div>
//           )}
          
//           {isWaitingForResponse && (
//             <div className="waiting-indicator">
//               <div className="waiting-indicator-bubble">
//                 <PulseLoader size={8} color="#DC2626" speedMultiplier={0.7} />
//               </div>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default MessageList;

// src/components/ChatBot/MessageComponents.js
import React, { useEffect } from 'react';
import { PulseLoader } from 'react-spinners';
import { useChat } from './ChatContext';

// MessageWithRating: Add messageNumber prop and display it
const MessageWithRating = ({ message, index, streamType, messageNumber }) => {
  const [showCorrection, setShowCorrection] = React.useState(false);
  const isUserMessage = message.role === 'user';
  const showRatingArea = isUserMessage && streamType === 'chat'; // Rating only for chat

  return (
    <div key={`${streamType}-${index}-${message.content.slice(0,10)}`} // More robust key
      className={`message-wrapper ${isUserMessage ? 'message-wrapper-user' : 'message-wrapper-bot'}`}>
      <div className="message-container">
        <div className={`message-bubble ${isUserMessage ? 'message-bubble-user' : 'message-bubble-bot'}`}>
          {message.content}
          {isUserMessage && messageNumber && streamType === 'chat' && (
            <span className="message-number">{messageNumber}</span>
          )}
        </div>
        {showRatingArea && (
          <div className="message-rating">
            {message.rating !== undefined && message.rating !== null ? (
              <>
                <div className="rating-container">
                  <span>Points earned: +{message.rating}</span>
                  {message.correctedSentence && (
                    <button onClick={() => setShowCorrection(!showCorrection)} className="correction-toggle">
                      {showCorrection ? "▲" : "▼"}
                    </button>
                  )}
                </div>
                {showCorrection && message.correctedSentence && (
                  <div className="correction-box">{message.correctedSentence}</div>
                )}
              </>
            ) : ( <span>Calculating points... <PulseLoader size={4} color="#888" /></span> )}
          </div>
        )}
      </div>
    </div>
  );
};

export const MessageList = () => {
  const {
    messages, tutorMessages, chatContainerRef,
    isLoading, isWaitingForResponse, activeStream
  } = useChat();

  const messagesToDisplay = activeStream === 'chat' ? messages : tutorMessages;

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messagesToDisplay, isWaitingForResponse]);

  let userMessageCounter = 0;

  return (
    <div ref={chatContainerRef} className="message-list-container">
      {isLoading ? ( <div className="loading-message">Loading...</div> ) : (
        <>
          {Array.isArray(messagesToDisplay) && messagesToDisplay.length > 0 ? (
            messagesToDisplay.map((message, index) => {
              let currentMessageNumber = null;
              // Only count and number user messages in the 'chat' stream
              if (activeStream === 'chat' && message.role === 'user') {
                userMessageCounter++;
                currentMessageNumber = userMessageCounter;
              }
              return (
                <MessageWithRating
                  key={index} // Consider a more unique key if messages can be identical
                  message={message}
                  index={index}
                  streamType={activeStream}
                  messageNumber={currentMessageNumber}
                />
              );
            })
          ) : (
            // If messagesToDisplay is empty and not waiting, show appropriate placeholder
            !isWaitingForResponse && (
              <div className="empty-message">
                {activeStream === 'chat'
                  ? "Start the conversation!"
                  // The initial tutor message is now added in ChatContext, so this will only show if that array is also empty
                  : "Ask the tutor about your English in the chat!"
                }
              </div>
            )
          )}
          {isWaitingForResponse && (
            <div className="waiting-indicator">
              <div className="waiting-indicator-bubble">
                <PulseLoader size={8} color="#DC2626" speedMultiplier={0.7} />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MessageList;